import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetStores = async (params: {
  page: number;
  limit: number;
  search?: string;
  tenant_id?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/stores`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load stores.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetActiveStores = async (params?: {
  tenant_id?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/stores/active`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load active stores.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateStore = async (formData: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/stores/create`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create store.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const UpdateStore = async (formData: any): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/stores/update`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update store.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeleteStore = async (payload: {
  id: number;
  tenant_id?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/stores/delete`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete store.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const UpdateStoreLocation = async (params: {
  id: string;
  latitude: number;
  longitude: number;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(
      `/stores/update-location`,
      params,
    );
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to update store location.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
